// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "hooks/use-http";

// material styles
import { Grid, IconButton, Tooltip } from "@mui/material";

// material icons
import { Edit } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { getAllUsersRequest } from "api/requests/users";
import { convertNum } from "helper/convert-num";

// users head cells
const headCells = GenerateHeadCell("users_list");

function DisplayUsers() {
  const { request, loading, setLoading } = useHttp(false);

  const navigate = useNavigate();

  // states for filtered
  const [searchValue, setSearchValue] = useState("");

  // users data state
  const [usersData, setUsersData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  // search handler
  const handleSearch = (e) => setSearchValue(e);

  // handle date
  const dateHandler = (value) =>
    value
      .split(" ")[0]
      // .format("YYYY-MM-DD")
      .split("-")
      .map((item) => convertNum(item))
      .join("/");

  // get all Users data
  const getUsersData = useCallback(async () => {
    setLoading(true);

    const res = await request({
      url: getAllUsersRequest,
      values: {
        skip: searchValue ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: searchValue ? 100 : PAGINATION_LIMIT,
        search: searchValue || null,
      },
      isMulty: true,
    });

    if (res) {
      if (res.data.count < 1) {
        return setUsersData({
          count: res.data.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }

      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        full_name: items.full_name,
        phone_number: items.phone_number,
        email: items.email,
        birth_date: items.birth_date
          ? dateHandler(items.birth_date.jdate)
          : "ثبت نشده",
        edit: (
          <IconButton
            color="primary"
            onClick={() => {
              navigate(`/users/edit/${items.id}`);
            }}
          >
            <Tooltip title="ویرایش" placement="top">
              <Edit />
            </Tooltip>
          </IconButton>
        ),
      }));

      setUsersData({
        data: transformedData,
        count: res.data.count,
      });
    }
    setLoading(false);
  }, [page, searchValue]);

  useEffect(() => {
    getUsersData();
  }, [getUsersData]);
  return (
    <DrawerCM title="کاربران" onSearch={handleSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست کاربران"
                rows={usersData.data}
                headCells={headCells}
                page={page}
                colspan={usersData.count === 0 ? "11" : ""}
                fontSize="12px"
                cellFontSize="12px"
              />
            </Grid>
            {usersData.count < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(_, val) => setPage(val)}
                page={page}
                count={usersData.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}

export default DisplayUsers;
